import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/main.css'
import { currency } from './commons/currency'
import { display_date, vip_level, vip_level_color, capitalize, display_value, display_color, display_text_color } from './commons/formater'
import VueResource from 'vue-resource'
import vuetify from './plugins/vuetify'
// import VueMuuriGrid from 'vue-muuri-grid';
import VueCookies from 'vue-cookies'
import i18n from "./i18n/";

Vue.use(VueCookies)
Vue.use(VueResource);
Vue.use(require('vue-shortkey'))
// Vue.use(VueMuuriGrid);
Vue.filter('currency', currency)
Vue.filter('display_date', display_date)
Vue.filter('vip_level', vip_level)
Vue.filter('vip_level_color', vip_level_color)
Vue.filter('capitalize', capitalize)
Vue.filter('display_value', display_value)
Vue.filter('display_color', display_color)
Vue.filter('display_text_color', display_text_color)

import currencyInput from './components/general/CurrencyInput';
Vue.component('h-currency-input', currencyInput);
import widgetTemp from '@/components/dashboard/WidgetTemp';
Vue.component('widget-temp', widgetTemp);
Vue.config.productionTip = false;

// Global directive for dual scrollbar on v-data-table
Vue.directive('dual-scroll', {
  inserted(el) {
    setTimeout(() => {
      setupDualScrollbar(el);
    }, 500);
  },
  componentUpdated(el) {
    setTimeout(() => {
      setupDualScrollbar(el);
    }, 100);
  }
});

function setupDualScrollbar(el) {
  const wrapper = el.querySelector('.v-data-table__wrapper');
  if (!wrapper) return;

  // Skip if already setup
  if (wrapper.dataset.dualScrollSetup === 'true') return;

  const table = wrapper.querySelector('table');
  if (!table) return;

  // Check if scrollable
  if (table.offsetWidth <= wrapper.offsetWidth) {
    // Remove top scroll if exists but not needed
    const existingTopScroll = wrapper.previousElementSibling;
    if (existingTopScroll && existingTopScroll.classList.contains('dual-scroll-top')) {
      existingTopScroll.remove();
    }
    return;
  }

  wrapper.dataset.dualScrollSetup = 'true';

  // Create or update top scrollbar
  let topScroll = wrapper.previousElementSibling;
  if (!topScroll || !topScroll.classList.contains('dual-scroll-top')) {
    topScroll = document.createElement('div');
    topScroll.className = 'dual-scroll-top';
    topScroll.style.overflowX = 'auto';
    topScroll.style.overflowY = 'hidden';
    topScroll.style.height = '8px';
    const topScrollInner = document.createElement('div');
    topScrollInner.style.height = '1px';
    topScroll.appendChild(topScrollInner);
    wrapper.parentNode.insertBefore(topScroll, wrapper);
  }

  // Update inner width
  const topScrollInner = topScroll.querySelector('div');
  topScrollInner.style.width = table.offsetWidth + 'px';

  // Remove old listeners
  if (topScroll._scrollHandler) {
    topScroll.removeEventListener('scroll', topScroll._scrollHandler);
  }
  if (wrapper._scrollHandler) {
    wrapper.removeEventListener('scroll', wrapper._scrollHandler);
  }

  // Sync scroll
  let isTopScrolling = false;
  let isWrapperScrolling = false;

  topScroll._scrollHandler = () => {
    if (!isWrapperScrolling) {
      isTopScrolling = true;
      wrapper.scrollLeft = topScroll.scrollLeft;
      setTimeout(() => { isTopScrolling = false; }, 50);
    }
  };

  wrapper._scrollHandler = () => {
    if (!isTopScrolling) {
      isWrapperScrolling = true;
      topScroll.scrollLeft = wrapper.scrollLeft;
      setTimeout(() => { isWrapperScrolling = false; }, 50);
    }
  };

  topScroll.addEventListener('scroll', topScroll._scrollHandler);
  wrapper.addEventListener('scroll', wrapper._scrollHandler);
}

// Apply to all v-data-table on mount
Vue.mixin({
  mounted() {
    this.$nextTick(() => {
      if (this.$el && this.$el.querySelectorAll) {
        const tables = this.$el.querySelectorAll('.v-data-table');
        tables.forEach(table => {
          setupDualScrollbar(table);
        });
      }
    });
  },
  updated() {
    this.$nextTick(() => {
      if (this.$el && this.$el.querySelectorAll) {
        const tables = this.$el.querySelectorAll('.v-data-table');
        tables.forEach(table => {
          setupDualScrollbar(table);
        });
      }
    });
  }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
